'use es6';

import http from 'hub-http/clients/apiClient';
import { formatSharedTaskQueuesResponse } from 'reference-resolvers/formatters/formatSharedTaskQueues';
export const createGetSharedTaskQueues = ({
  httpClient
}) => args => httpClient.post('engagements/v1/queues/search-definitions', {
  data: {
    offset: args ? args.get('offset', 0) : 0,
    limit: args ? args.get('limit', 10) : 10,
    query: args ? args.get('query', '') : '',
    accessTypes: ['PUBLIC', 'SHARED']
  }
}).then(formatSharedTaskQueuesResponse);
export const getSharedTaskQueues = createGetSharedTaskQueues({
  httpClient: http
});